import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing.unit * 4,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  tabSelected: {},
  typography: {
    padding: theme.spacing.unit * 3,
  },
});

class CustomTabs extends React.Component {
  state = {
    value: 0,
  };

  render() {
    const { classes, headers, onChange} = this.props;
    const { value } = this.state;
   
    return (
      <div className={classes.root}>
        <Tabs value={value}
          onChange={(event, value) => {
            this.setState({value});
            onChange(value);
            
          }}
          classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}>
          {
            headers.map(title => (
              <Tab disableRipple
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label={title}
                style={{outline: 'none'}}
           
                />
            ))
          }
        </Tabs>
        <Typography className={classes.typography}></Typography>
      </div>
    );
  }
}

CustomTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  headers: PropTypes.object,
  onChange: PropTypes.func,
};

export default withStyles(styles)(CustomTabs);